import React from 'react';
import {Button, Form} from "react-bootstrap";

const AccountInformationStep = ({activeStep, setActiveStep}) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                    <div className="card-body">
                            <h5 className="text-center">Account Information</h5>

                            <div className="row">
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Identify Owner:</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Identify Owner" />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>ID Upload:</Form.Label>
                                        <Form.Control type="file" placeholder="Enter " />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Real/Fake:</Form.Label>
                                        <Form.Control type="text" placeholder="Real/Fake" />
                                    </Form.Group>
                                </div>
                                
                                <div className="col-lg-12 mt-5">
                                    <div className="row justify-content-between">
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre - 1)}
                                            >
                                                Previous
                                            </Button>
                                        </div>
                                        <div className="col-lg-3 d-flex mb-3">
                                            <Button
                                                variant="primary"
                                                className="text-white mt-auto w-100"
                                                onClick={() => setActiveStep(pre => pre + 1)}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AccountInformationStep;